import React from 'react';
import styled from 'styled-components';
import Colors from '@constants/Colors';

const ButtonFlatStyles = styled.button`
  background: transparent;
  font-weight: 600;
  font-size: ${({ fontSize }) => fontSize || '16px'};
  line-height: 16px;
  color: ${Colors.periwinkleStrong};
  text-align: center;
  border: none;
  font-family: inherit;
  height: auto;
  margin: auto;
  ${({ padding }) => padding && `padding: ${padding};`}
  cursor: pointer;
  outline: 0;
  span {
    cursor: pointer;
  }

  > * {
    color: inherit;
    text-decoration: ${({ textDecoration }) => textDecoration || 'none'};
  }
`;

const ButtonFlat = ({ children, ...rest }) => (
  <ButtonFlatStyles {...rest}>{children}</ButtonFlatStyles>
);

export default ButtonFlat;
